/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { Typography, Modal, Row, Col, message, Button } from 'antd';
import moment from 'moment';
import { DataService } from '../../../config/dataService/dataService';
import { API_ENDPOINT, BLOOD_GROUPS, EMPLOYEE_TYPE, GENDERS } from '../../../config/config';
import ImagePreview from '../image-preview';

const { Text, Title } = Typography;

const DetailsDialog = ({ showDialog, isEdit = false, editId }) => {
  const [busy, setBusy] = useState(true);
  const [profilePicture, setProfilePicture] = useState(null);
  const [employeeData, setEmployeeData] = useState(null);
  const [isImageModalOpen, setIsImageModalOpen] = useState(false);

  const fetchEmployeeData = async (id) => {
    try {
      setBusy(true);
      const response = await DataService.post('/common/emp/get-by-id', { id });
      if (response.data.status) {
        const { data } = response.data;
        setEmployeeData({
          ...data,
          date_of_birth: data.date_of_birth ? moment(data.date_of_birth).format('D MMM YYYY') : 'N/A',
          blood_group: BLOOD_GROUPS.find((group) => group.id === Number(data.blood_group_id))?.label || 'N/A',
          gender: GENDERS.find((gender) => gender.id === Number(data.gender_id))?.label || 'N/A',
          designation: data.desig_title,
          emp_type: EMPLOYEE_TYPE.find((type) => type.id === Number(data.emp_type))?.label || 'N/A',
          is_biometric_verified: Number(data.is_biometric_verified) === 1 ? 'Verified' : 'Not Verified',
          is_police_verified: Number(data.is_police_verified) === 1 ? 'Verified' : 'Not Verified',

          isBMV: Number(data.is_biometric_verified) === 1 || false,
          isPV: Number(data.is_biometric_verified) === 1 || false,
        });
        setProfilePicture(`${API_ENDPOINT}/${data.profile_picture}`);
      } else {
        message.error(response.data.message || response.message);
      }
      setBusy(false);
    } catch (error) {
      setBusy(false);
      console.error('Error fetching employee data:', error);
      message.error(error.message);
    }
  };

  useEffect(() => {
    if (isEdit && editId) {
      fetchEmployeeData(editId);
    }
  }, [isEdit, editId]);

  if (!employeeData) return null;

  const classesValue = 'text-black font-bold'

  return (
    <Modal
      open
      title='Employee Details'
      okText='Close'
      cancelText='Close'
      width='70%'
      centered
      confirmLoading={busy}
      footer={[
        // <Button
        //   key='cancel'
        //   onClick={() => showDialog(false)}
        //   disabled={busy}
        //   style={{ padding: '8px 16px', border: 'none', background: '#1890ff', color: '#fff', borderRadius: '4px' }}
        // >
        //   Close
        // </Button>,
        <Button key="cancel" onClick={() => showDialog(false)} disabled={busy}>
          Close
        </Button>
      ]}
      onCancel={() => showDialog(false)}
    >
      {/* Enlarged Image Modal */}
      <ImagePreview
        visible={isImageModalOpen}
        imageSrc={profilePicture}
        onClose={() => setIsImageModalOpen(false)}
      />

      {/* Profile Picture Section */}
      <div className="flex flex-col align-items-center" style={{ marginBottom: 20 }}>
        <img
          src={profilePicture || require('../../../static/img/avatar/profileImage.png')}
          alt='Profile'
          style={{ width: 100, height: 100, borderRadius: '50%', cursor: 'pointer' }}
          onClick={() => {
            if (profilePicture) setIsImageModalOpen(true);
          }}
        />
      </div>
      <div className='space-y-4'>
        {/* Employee Details */}
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Text >Name:</Text> <Text className={classesValue}>{employeeData.name}</Text>
          </Col>
          <Col span={12}>
            <Text >Father&apos;s Name:</Text> <Text className={classesValue}>{employeeData.father_name}</Text>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Text >CNIC:</Text> <Text className={classesValue}>{employeeData.cnic}</Text>
          </Col>
          <Col span={12}>
            <Text >Contact:</Text> <Text className={classesValue}>{employeeData.contact}</Text>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Text >Designation:</Text> <Text className={classesValue}>{employeeData.designation}</Text>
          </Col>
          <Col span={12}>
            <Text >Gender:</Text> <Text className={classesValue}>{employeeData.gender}</Text>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Text >Date of Birth:</Text> <Text className={classesValue}>{employeeData.date_of_birth}</Text>
          </Col>
          <Col span={12}>
            <Text >Blood Group:</Text> <Text className={classesValue}>{employeeData.blood_group}</Text>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Text >NADRA Verified:</Text> <Text className={`${classesValue} ${!employeeData.isBMV ? ' !text-red-400 ' : ' !text-green-600 '}`}>{employeeData.is_biometric_verified}</Text>
          </Col>
          <Col span={12}>
            <Text >Police Verified:</Text> <Text className={`${classesValue} ${!employeeData.isPV ? ' !text-red-400 ' : ' !text-green-600 '}`}>{employeeData.is_police_verified}</Text>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Col span={12}>
            <Text >Employee Type:</Text> <Text className={classesValue}>{employeeData.emp_type}</Text>
          </Col>
          <Col span={12}>
            <Text >Company:</Text> <Text className={classesValue}>{employeeData.comp_name}</Text>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default DetailsDialog;
